import Messages from './messages.js'

/**
 * Represents a geo-location coordinates
 * https://developer.mozilla.org/en-US/docs/Web/API/GeolocationCoordinates
 * 
 * @typedef {Object} GeolocationCoordinates
 * @property {number} latitude
 * @property {number} longitude
 * @property {number} altitude
 * @property {number} speed
 */

/**
 * Represents a geo-location position
 * https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPosition
 * 
 * @typedef {Object} GeolocationPosition
 * @property {GeolocationCoordinates} corods
 * @property {number} timestamp
 */

export default class GpsClient {

  constructor(socket) {
    this.socket = socket
  }

  /**
   * Get last known location
   * 
   * @returns {Promise<GeolocationPosition|null>}
   */
  async lastKnownLocation() {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Gps_LastKnownLocation);
    } catch (error) {
      console.error(`GpsClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return response.data
  }

  /**
   * Get current location
   * 
   * @param {*} timeout 
   * @returns {Promise<GeolocationPosition|null>}
  */
  async currentLocation(timeout = 60) {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Gps_CurrentLocation, timeout);
    } catch (error) {
      console.error(`GpsClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return response.data
  }
}